import React, { useRef } from "react";
import Product from "../components/Product";

function Best() {
  const scrollRef = useRef<HTMLDivElement | null>(null);
  console.log(scrollRef.current);
  const scr = () => {
    console.log(window.screen);
    console.log(scrollRef.current?.offsetWidth);
    console.log(scrollRef.current?.scrollWidth);
    scrollRef.current?.scrollTo(scrollRef.current?.scrollWidth - 200, 0);
  };
  const prod = [
    {
      id: 1,
      title:
        "BUTTA DROP WHIPPED OIL BODY CREAM WITH TROPICAL OILS + SHEA BUTTER",
      bg: "bg-hero",
    },
    {
      id: 2,
      title:
        "BUTTA DROP WHIPPED OIL BODY CREAM WITH TROPICAL OILS + SHEA BUTTER",
      bg: "bg-heroii",
    },
    {
      id: 3,
      //   title:
      //     "BUTTA DROP WHIPPED OIL BODY CREAM WITH TROPICAL OILS + SHEA BUTTER",
      bg: "bg-heroiii",
    },
    {
      id: 4,
      title:
        "BUTTA DROP WHIPPED OIL BODY CREAM WITH TROPICAL OILS + SHEA BUTTER",
      bg: "bg-heroiv",
    },
    {
      id: 5,
      //   title:
      //     "BUTTA DROP WHIPPED OIL BODY CREAM WITH TROPICAL OILS + SHEA BUTTER",
      bg: "bg-hero",
    },
    {
      id: 6,
      title:
        "BUTTA DROP WHIPPED OIL BODY CREAM WITH TROPICAL OILS + SHEA BUTTER",
      bg: "bg-heroii",
    },
  ];
  // React.RefObject<HTMLDivElement>;
  return (
    <div className="w-11/12 min-h-[70vh] relative py-10 flex justify-center flex-col gap-5">
      <div className="flex flex-col gap-0.5">
        <p className="text-3xl font-bold uppercase tracking-wide">
          Best of Babl
        </p>
        <p className="text-sm font-semibold">
          Our best sellers and fan favorites
        </p>
      </div>
      <div
        ref={scrollRef}
        className="overflow-auto flex gap-10 relative justify-start items-center"
      >
        {prod.map((pro) => {
          return <Product key={pro.id} title={pro.title} bg={pro.bg} />;
        })}
      </div>
      <div
        onClick={scr}
        className="bg-white/70 backdrop-blur-lg w-14 h-14 cursor-pointer rounded-full flex justify-center items-center absolute right-4 z-50"
      >
        <span className="material-symbols-rounded text-[2rem] text-black">
          chevron_right
        </span>
      </div>
    </div>
  );
}

export default Best;
